/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  addDecoderSizePrefix,
  addEncoderSizePrefix,
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getI64Decoder,
  getI64Encoder,
  getStructDecoder,
  getStructEncoder,
  getU32Decoder,
  getU32Encoder,
  getUtf8Decoder,
  getUtf8Encoder,
  type Address,
  type Codec,
  type Decoder,
  type Encoder,
} from "@solana/kit";

export type AuditTrailInitializedEvent = {
  entity: Address;
  entityType: string;
  timestamp: bigint;
};

export type AuditTrailInitializedEventArgs = {
  entity: Address;
  entityType: string;
  timestamp: number | bigint;
};

export function getAuditTrailInitializedEventEncoder(): Encoder<AuditTrailInitializedEventArgs> {
  return getStructEncoder([
    ["entity", getAddressEncoder()],
    ["entityType", addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder())],
    ["timestamp", getI64Encoder()],
  ]);
}

export function getAuditTrailInitializedEventDecoder(): Decoder<AuditTrailInitializedEvent> {
  return getStructDecoder([
    ["entity", getAddressDecoder()],
    ["entityType", addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder())],
    ["timestamp", getI64Decoder()],
  ]);
}

export function getAuditTrailInitializedEventCodec(): Codec<
  AuditTrailInitializedEventArgs,
  AuditTrailInitializedEvent
> {
  return combineCodec(
    getAuditTrailInitializedEventEncoder(),
    getAuditTrailInitializedEventDecoder(),
  );
}
